import { Injectable, NgZone } from '@angular/core';
import { Subject } from 'rxjs';
import AdjuntosClass from '../model/api/datos/adjuntosClass';
import { UtilService } from './util.service';

@Injectable({
  providedIn: 'root'
})
export class AdjuntoService {

  public UploadAdjuntoSubject = new Subject<AdjuntosClass>()

  constructor(
    private util: UtilService,
    private zone: NgZone
  ) {}

  public async updateAdjunto(adjunto: AdjuntosClass, base64: string, categoria: string): Promise<void> {
    let base64Data = base64.substring(base64.indexOf(",") + 1)
    adjunto.SHA256 = await this.util.SHA256FromBase64Data(base64Data)
    adjunto.AdjuntoData = base64
    adjunto.Categoria = categoria
  }
  
  public async AdjuntarArchivo(localId: number, categoria: string): Promise<void> {
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = '*'
    input.style.display = 'none'
    input.multiple = true

    const _this = this
    input.onchange = async (event) => {
      const files = (event.target as HTMLInputElement).files
      if (files && files.length) {
        for (let i = 0; i < files.length; ++i) {
          let file = files[i]
          let base64 = await _this.SubirFichero.call(_this, file)
          await _this.AddFichero.call(_this, file.name, base64, localId, categoria)
        }
      }
    }

    input.click()
  }

  public SubirFichero(file: File): Promise<string> {
    return new Promise<string>((resolve) => {
      const reader = new FileReader()
      reader.onload = () => {
        const base64String = reader.result as string
        resolve(base64String)
      }
      reader.readAsDataURL(file)
    })
  }

  public async AddFichero(fileName: string, base64: string, localId: number, categoria: string): Promise<void> {

    // Añadimos el adjunto
    let adjunto = new AdjuntosClass()
    adjunto.Id = 0
    adjunto.OrdenLocalId = localId
    adjunto.FileName = fileName
    adjunto.AdjuntoData = base64
    adjunto.Categoria = categoria
    let base64Data = base64.substring(base64.indexOf(",") + 1)
    adjunto.SHA256 = await this.util.SHA256FromBase64Data(base64Data)

    console.log(`Fichero añadido: ${adjunto.FileName}`)

    this.zone.run(async () => {
      this.UploadAdjuntoSubject.next(adjunto)
    })

  }

}
